module.exports = __webpack_public_path__ + "img/9-02.20256cbd.png";